export const REQUEST_BANNER = 'banner/REQUEST_BANNER';
export const RECEIVE_BANNER = 'banner/RECEIVE_BANNER';
export const REQUEST_BANNER_ID = 'banner/REQUEST_BANNER_ID';
export const RECEIVE_BANNER_ID = 'banner/RECEIVE_BANNER_ID';
export const SET_BANNER_CLOSE = 'banner/SET_BANNER_CLOSE';
